function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M25.6,2.502c-0.973,0.432-2.004,0.715-3.061,0.839c1.115-0.664,1.95-1.713,2.349-2.948 c-1.046,0.621-2.19,1.059-3.384,1.294c-1.008-1.075-2.416-1.685-3.891-1.684C14.671,0,12.282,2.384,12.28,5.327 c0,0.002,0,0.003,0,0.005c0,0.407,0.047,0.813,0.139,1.21C8.133,6.328,4.141,4.305,1.434,0.978C0.96,1.792,0.711,2.717,0.713,3.658 c-0.002,1.781,0.888,3.446,2.37,4.435C2.237,8.067,1.409,7.839,0.67,7.427c0,0.022,0,0.045,0,0.067 c0.001,2.537,1.788,4.722,4.274,5.225c-0.456,0.124-0.927,0.187-1.399,0.187c-0.336-0.002-0.671-0.035-1-0.101 c0.697,2.171,2.697,3.657,4.977,3.7c-1.887,1.482-4.218,2.286-6.618,2.282c-0.425,0-0.849-0.025-1.271-0.075 c2.437,1.566,5.272,2.397,8.169,2.395c8.316,0.053,15.102-6.647,15.154-14.964c0-0.064,0-0.128,0-0.192c0-0.231,0-0.461-0.016-0.691 C23.985,4.506,24.885,3.572,25.6,2.502z"
});

var SvgIconTwitter = function SvgIconTwitter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "25.975px",
    height: "21.109px",
    viewBox: "0 0 25.975 21.109",
    enableBackground: "new 0 0 25.975 21.109",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconTwitter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-twitter.4d088886.svg";
export { ForwardRef as ReactComponent };